import React from 'react';

export function InfoIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M22 16a2 2 0 114 0 2 2 0 01-4 0zm0 8a2 2 0 114 0v8a2 2 0 11-4 0v-8zm2-20C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z" />
    </svg>
  );
}
